export const data ={
    experience: [
        {
            title: "MERN Stact Internship",
            SubTitle: "Digipodium Lucknow, India",
            description:"I have experience working on the MERN stack, which stands for MongoDB, Express.js, React.js, and Node.js. In the MERN stack, MongoDB is used as the database, Express.js as the backend framework, React.js for building user interfaces on the frontend, and Node.js as the runtime environment for server-side scripting. This technology stack is popular for developing full-stack web applications"
        },
        {
            title: "Junior Java Fullstack developer",
            SubTitle: "Tata Strive Gujarat, India",
            description:"Four-month training program that includes theoretical and practical knowledge of frontend technologies such as HTML, CSS, JavaScript, React, Bootstrap, as well as backend technologies including Java and Spring Boot"      
         }
    ],
    education: [
        {
            title: "High School",
            SubTitle: "Hindustan Aeronautic Limited",
            description:"2017"
        },
        {
            title: "Intermediate",
            SubTitle: "Hindustan Aeronautic Limited",
            description:"2019"
        },
        {
            title: "Graduation",
            SubTitle: "Shri Ramswaroop Memorial College of Engineering and Management",
            description:"2019-2023"
        },
    ]

}